/**
 * AdminMassageIntakeAddon — Iter 132.
 *
 * Purchase page for the Massage Intake (SOAP) module. Thin wrapper over
 * the generic <AdminAddonPurchase/> component, wiring the shared UI to
 * the massage_intake addon in the backend's ADDON_CATALOGUE.
 */
import React from 'react';
import AdminAddonPurchase from '../../components/AdminAddonPurchase';

export default function AdminMassageIntakeAddon() {
  return (
    <AdminAddonPurchase
      addonId="massage_intake"
      moduleLink={{ href: '/admin/massage-assessment', label: 'the Massage Assessment' }}
    />
  );
}
